// extracted by mini-css-extract-plugin
export default {"overridesActionIcon":"ActionIcon-module--overrides--ActionIcon--zdnlQ"};